import React, { useState } from "react";
import Sidebar from '../../components/Sidebar';
import HeaderUser from '../../components/HeaderUser';
import UserSettingsModal from '../../components/UserSettingsModal';
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from './Dashboard';
import Stats from './Stats';
import Links from './Links';
import ArchivedLinks from './ArchivedLinks';
import ExpiredLinks from './ExpiredLinks';

const getCurrentUser = () => {
  try {
    const u = localStorage.getItem('user');
    return u ? JSON.parse(u) : null;
  } catch {
    return null;
  }
};

export default function UserLayout() {
  const [user, setUser] = useState(getCurrentUser());
  const [openSettings, setOpenSettings] = useState(false);

  // Xử lý logout
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = "/";
  };

  // Xử lý cập nhật info
  const handleUpdateInfo = (info) => {
    setUser((u) => ({ ...u, ...info }));
    localStorage.setItem('user', JSON.stringify({ ...user, ...info }));
    setOpenSettings(false);
  };

  // Xử lý đổi mật khẩu
  const handleChangePassword = (oldPass, newPass) => {
    setOpenSettings(false);
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f8fafc" }}>
      <Sidebar />
      <div style={{ marginLeft: 225, flex: 1, display: "flex", flexDirection: "column" }}>
        <HeaderUser
          user={user}
          onLogout={handleLogout}
          onOpenSettings={() => setOpenSettings(true)}
        />
        <UserSettingsModal
          open={openSettings}
          onClose={() => setOpenSettings(false)}
          user={user}
          onUpdate={handleUpdateInfo}
          onChangePassword={handleChangePassword}
        />
        <main style={{ flex: 1, padding: "36px 32px" }}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="stats" element={<Stats />} />
            <Route path="links" element={<Links />} />
            <Route path="links/archived" element={<ArchivedLinks />} />
            <Route path="links/expired" element={<ExpiredLinks />} />
            {/* fallback khi path không khớp */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
